import { render, staticRenderFns } from "./emoticonModal.vue?vue&type=template&id=0d390a41&scoped=true&"
import script from "./emoticonModal.vue?vue&type=script&lang=js&"
export * from "./emoticonModal.vue?vue&type=script&lang=js&"
import style0 from "./emoticonModal.vue?vue&type=style&index=0&id=0d390a41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d390a41",
  null
  
)

export default component.exports